module.exports = __webpack_public_path__ + "static/img/alpaga-landing.50b3d05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alpaga-landing.png
// module id = 66
// module chunks = 0